import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import * as React from 'react';
import { ITableSort } from '../SmartTable';

interface IEnhancedTableHead extends ITableSort {
  columnData: any
  sortable: boolean
  onRequestSort: (newOrder: any) => void
  color: string
}

export default class EnhancedTableHead extends React.PureComponent<IEnhancedTableHead, {}> {
  public render() {
    const {
      columnData,
      sortable,
      order,
      orderBy,
      color,
    } = this.props;
    return (
      <TableHead style={{ backgroundColor: color }}>
        <TableRow>
          {columnData.map((column: any) => {
            return (
              <TableCell
                key={column.id}
              >
                {!column.notSortable && sortable ?
                  <TableSortLabel
                    active={orderBy === column.id}
                    direction={order as any}
                    onClick={this.createSortHandler(column.id)}>
                    {column.label}
                  </TableSortLabel> : column.label}
              </TableCell>
            )
          })}
        </TableRow>
      </TableHead>
    )
  }

  private createSortHandler = (property: any) => (event: any) => {
    const {
      order,
      orderBy,
      onRequestSort
    } = this.props;
    onRequestSort({orderBy: property, order: (orderBy === property && order === 'asc') ? 'desc' : 'asc'});
  };

}



// WEBPACK FOOTER //
// ./src/components/smartTable/EnhancedTableHeader.tsx